import { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  useTheme,
} from '@mui/material';
import {
  CPRStyledTableCell,
  CPRStyledTableCellFirst,
  CPRStyledTableCellHead,
  CPRStyledTableCellHeadNumbering,
  CPRStyledTableCellBodyNumbering,
} from 'routes/Main/style';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';
import { initialRestraint } from '../../initialStates';

const contentLabel = [
  {
    ko: [
      'am / pm',
      '1. 수분 공급 / 영양 / 배설 ',
      '2. 피부상태',
      '3. 정상가동범위 / 체위변경',
      '4. 의사소통 (손 닿는 위치에 호출 벨)',
      '5. 순환 / 신경혈관상의 변화',
      '6. 임상상태와 행동의 사정',
      '7. 신체보호대 제거를 위한 사정',
      '8. 억제 경감 / 신체 보호대 제거',
      '9. 행동 / 안전 체크(15분마다)',
      '10. 활력징후 측정 (가능하면)',
      '사정자 이름',
    ],
    idForApi: 'observation',
    koForApi: [
      'am_pm',
      'hydration',
      'skin',
      'position',
      'commu',
      'circul',
      'behavior',
      'for_removal',
      'removal',
      'behavior_15',
      'vital',
      'name',
    ],
    desc: Array(12).fill(' '),
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}

const Contents = (props: Props) => {
  const { palette } = useTheme();

  const { disabled, setValue, getValues, register } = props;

  const [cprRecord, setCprRecord] = useState(initialRestraint);

  const timeStart = 0;

  const timeCount = new Array(12).fill(timeStart).map((num, i) => {
    if (i === 0 || i === 6) return 12;
    if (i > 6) return (i - 6) * 2;
    return (num + i) * 2;
  });

  useEffect(() => {
    if (getValues('observation')) {
      setCprRecord(prev => ({
        ...prev,
        observation: getValues('observation'),
      }));
    } else {
      setValue('observation', cprRecord.observation);
    }
  }, []);

  useEffect(() => {}, [cprRecord]);

  return (
    <>
      <Box
        sx={{
          width: '97%',
          marginTop: '30px',
          marginRight: 'auto',
          marginLeft: 'auto',
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <CPRStyledTableCellHead colSpan={1} align="center">
                Time
              </CPRStyledTableCellHead>

              {timeCount.map((min, i) => (
                <CPRStyledTableCellHeadNumbering
                  colSpan={1}
                  align="right"
                  sx={{ paddingRight: '5px' }}
                  key={min + i}
                >
                  {min}
                </CPRStyledTableCellHeadNumbering>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {contentLabel.map(
              (
                content: {
                  ko: string[];
                  desc: string[];
                  koForApi: string[];
                  idForApi: string;
                },
                i
              ) => {
                return (
                  <TableRow>
                    <CPRStyledTableCell>
                      {content.ko.map((el, i) => {
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '44px',
                              borderBottom:
                                i !== content.ko.length - 1
                                  ? '1px solid lightgray'
                                  : '',
                            }}
                          >
                            <Box
                              sx={{
                                width: '250px',
                                whiteSpace: 'pre',
                                padding: '0 0 0 5px',
                              }}
                            >
                              {content.ko[i]}
                            </Box>
                          </TableRow>
                        );
                      })}
                    </CPRStyledTableCell>

                    {content.desc.map((_, descIdx) => {
                      return (
                        <CPRStyledTableCellBodyNumbering>
                          {content.ko.map((_, koIdx) => {
                            if (content.ko[koIdx].includes('. ')) {
                              return (
                                <TableRow
                                  sx={{
                                    lineHeight: '44px',
                                    borderBottom: '1px solid lightgray',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      minWidth: '75px',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Checkbox
                                      size="small"
                                      {...register(
                                        `${content.idForApi}.${content.koForApi[koIdx]}${descIdx}`
                                      )}
                                      checked={
                                        // @ts-ignore
                                        cprRecord.observation[
                                          `${content.koForApi[koIdx]}${descIdx}`
                                        ] === true
                                      }
                                      onChange={(_, checked) => {
                                        setValue(
                                          `${content.idForApi}.${content.koForApi[koIdx]}${descIdx}`,
                                          checked
                                        );
                                        setCprRecord(prev => {
                                          const key = `${content.koForApi[koIdx]}${descIdx}`;
                                          const idForApi =
                                            content.idForApi as keyof typeof prev;
                                          return {
                                            ...prev,
                                            [idForApi]: {
                                              ...(prev[idForApi] as object),
                                              [key]: checked,
                                            },
                                          };
                                        });
                                      }}
                                    />
                                  </Box>
                                </TableRow>
                              );
                            }

                            return (
                              <TableRow
                                sx={{
                                  lineHeight: '44px',
                                  borderBottom: '1px solid lightgray',
                                }}
                              >
                                <Box
                                  sx={{
                                    minWidth: '60px',
                                    textAlign: 'center',
                                  }}
                                >
                                  <input
                                    disabled={disabled}
                                    style={{
                                      border: 'none',
                                      width: '100%',
                                      height: '44px',
                                    }}
                                    {...register(
                                      `${content.idForApi}.${
                                        content.koForApi[koIdx]
                                      }${descIdx + timeStart}`
                                    )}
                                    value={
                                      // @ts-ignore
                                      cprRecord[content.idForApi][
                                        `${content.koForApi[koIdx]}${
                                          descIdx + timeStart
                                        }`
                                      ]
                                      // 어느칸에 무슨값들어갔는지 보기위함
                                      // `${content.koForApi[koIdx]}${
                                      //   descIdx + timeStart
                                      // }`
                                    }
                                    onChange={e => {
                                      const key = `${content.koForApi[koIdx]}${
                                        descIdx + timeStart
                                      }`;
                                      setCprRecord(prev => {
                                        const idForApi =
                                          content.idForApi as keyof typeof prev;
                                        return {
                                          ...prev,
                                          [idForApi]: {
                                            ...(prev[idForApi] as object),
                                            [key]: e.target.value,
                                          },
                                        };
                                      });
                                    }}
                                  />
                                </Box>
                              </TableRow>
                            );
                          })}
                        </CPRStyledTableCellBodyNumbering>
                      );
                    })}
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </Table>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-end'}
        sx={{ marginTop: '20px', width: '94%' }}
      >
        <Typography sx={{ fontSize: '12px', color: `${palette.primary.main}` }}>
          해당 기록지는 충청대학교 간호학과의 협조를 통해 제작하였습니다.
        </Typography>
      </Box>
    </>
  );
};

export default Contents;
